import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import styles from './index.less';
import Store from './store';
import toWebpImage from '@src/utils/to-webp-image';

/**
 * fifthPage
 * @param store {fifthPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FifPage = ({ store, mechaId, kvImg }) => {
  store.use();

  return (
    <div className={cx(styles.mecha)} style={{ backgroundImage: `url(${kvImg})` }}>
      <Link
        data-mecha-id={mechaId}
        className={styles.btnDetail}
        style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/btn-view.png'))})` }}
      />
    </div>
  );
};

export default wrapStore(FifPage, Store);
